import React, { FC } from 'react';
import { Button } from '@clearcover/atlas';
import { useHistory } from 'react-router-dom';

import styles from './styles.module.css';

export const NetworkError: FC = () => {
  const history = useHistory();

  return (
    <div className={styles.container}>
      <h2>We experienced an error, please try refreshing the page.</h2>
      <h3 className={styles.secondaryHeading}>
        Contact Clearcover support if this problem persists.
      </h3>
      <Button
        data-testid="network-error-refresh-button"
        variant="secondary"
        onClick={() => {
          history.go(0);
        }}
      >
        Refresh Page
      </Button>
    </div>
  );
};
